const NAME = 'CATEGORIES';

export const types = {
  GET_REQUEST: `${NAME}/GET_REQUEST`,
  SET_CATEGORIES: `${NAME}/SET_CATEGORIES`,
  SET_SELECTED: `${NAME}/SET_SELECTED`,
  ERROR: `${NAME}/ERROR`,
};

export const actions = {
  getRequest: () => ({ type: types.GET_REQUEST }),
  setCategories: (categories) => ({
    type: types.SET_CATEGORIES,
    payload: categories,
  }),
  setSelected: (selected) => ({
    type: types.SET_SELECTED,
    payload: selected,
  }),
  error: (error) => ({ type: types.ERROR, error }),
};

const initialState = {
  byId: {},
  allIds: [],
  selected: '',
  isFetching: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case types.SET_CATEGORIES:
      return {
        ...state,
        ...payload,
        isFetching: false,
      };
    case types.SET_SELECTED:
      return {
        ...state,
        selected: payload,
      };
    case types.ERROR:
      return {
        ...state,
        ...payload,
        isFetching: false,
      };
    default:
      return state;
  }
};
